import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CompanyService } from '../../../../../core/auth/_services/company.service';

@Component({
    selector: 'app-logo-body',
    templateUrl: 'logo-body.component.html',
    styleUrls: [
        'logo-body.component.scss'
    ]
})

export class LogoBodyComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];
    logoImageBytea: any;
    logoImageType: any;

    defaultLogoSrc = './assets/media/logos/image-not-found-2.jpg';
    defaultLogoImageType = 'jpg';

    constructor(
        private companyService: CompanyService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.subscriptions.push(
            this.companyService.companyLoaded$.pipe(
                filter(loaded => loaded == true)
            ).subscribe(() => {
                const company = this.companyService.getCurrentCompany();
                //console.log("logo-body: loaded company");console.dir(company);
                try {
                    this.logoImageBytea = company.icon_file;
                    const splited = company.icon_filename.split('.');
                    this.logoImageType = splited[splited.length-1];
                    /*console.dir({
                        imgtype: this.logoImageType,
                        splited
                    })*/
                } catch (err) {
                    //console.log(err);
                    this.logoImageBytea = null;
                    this.logoImageType = null;
                }
                this.cdr.detectChanges();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
